/** Vehicle numbers: letters and digits only (no spaces or special characters). */

export const VEHICLE_NUMBER_FORMAT_MSG =
  "Vehicle number must be letters and digits only (no spaces or special characters).";

export const VEHICLE_NUMBER_PLACEHOLDER = "e.g. PB10XX1234";

/** Strip spaces/special chars and uppercase while typing. */
export function sanitizeVehicleNumberInput(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

/** Normalize for compare / API — same rules as backend. */
export function normalizeVehicleNumber(value) {
  return sanitizeVehicleNumberInput(value);
}

export function isValidVehicleNumber(value, { allowEmpty = false } = {}) {
  const raw = String(value || "").trim();
  if (!raw) return allowEmpty;
  return /^[A-Za-z0-9]+$/.test(raw);
}
